import { useEffect } from 'react'

export function useIndustriesNavbarScroll() {
   useEffect(() => {
      const handleScroll = () => {
         const navbar = document.querySelector('.navbar')
         if (!navbar) return

         if (window.scrollY > 100) {
            navbar.classList.add('scrolled')
            navbar.classList.remove('industries-nav')
         } else {
            navbar.classList.remove('scrolled')
            navbar.classList.add('industries-nav')
         }
      }

      window.addEventListener('scroll', handleScroll)
      handleScroll() // Call once on mount in case page is already scrolled

      return () => {
         window.removeEventListener('scroll', handleScroll)
      }
   }, [])
}
